"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const styled_1 = require("../styled");
const navigation_1 = require("../navigation");
const AkTag = require("@atlaskit/tag").default;
const AkTagGroup = require("@atlaskit/tag-group").default;
const AkTooltip = require("@atlaskit/tooltip").default;
let nextTagsId = 0;
class TagsState {
}
// This component renders a list of tags.
class Tags extends React.Component {
    constructor(props) {
        super(props);
        // TODO remove id autogeneration, ask for id being provided as a parameter of `Tags`.
        // If two Tag components with same key created in different Tags Components - all Tags with the same keys will
        // be removed when just one is removed. Creating global unique keys for Tag components prevents that.
        this.state = {
            id: nextTagsId++,
            deletingTags: new Set()
        };
    }
    render() {
        let { color, tags, align, emptyMessage } = this.props;
        const items = this.props.tags;
        return (React.createElement("div", { className: "ptags" },
            React.createElement("h4", null, this.props.title),
            React.createElement("div", { className: align }, tags && tags.length > 0 ? (React.createElement(AkTagGroup, null, tags.map((tag, index) => {
                const akTag = (React.createElement(AkTooltip, { content: tag.value },
                    React.createElement(AkTag, { key: "" + index + tag.value, text: tag.value, color: color })));
                if (tag.link) {
                    return React.createElement(navigation_1.Link, { to: tag.link }, akTag);
                }
                return akTag;
            }))) : (React.createElement(styled_1.GrayText, { bold: true, className: "empty-tags" }, emptyMessage ? emptyMessage : "No tags.")))));
    }
}
exports.Tags = Tags;
